const initialState = {};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "SYNC_SHIFT_CALLED":
      return {
        ...state,
        shiftsCalled: action.payload,
      };
    case "SYNC_PEOPLE_WAITING":
      return {
        ...state,
        peopleWaiting: action.payload,
      };
    default:
      return state;
  }
};
export default reducer;
